module.exports = __webpack_public_path__ + "img/product-showcase-gallery-05.26ee5bb5.jpg";